/* eslint-disable */
export default {
  save: '저장',
} as const;

// @key: @#@"save"@#@ @source: @#@"Save"@#@
